import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react';

type Kind = 'info' | 'ok';
interface Toast {
  id: string;
  msg: string;
  kind: Kind;
}

type PushFn = (msg: string, kind?: Kind) => void;

const ToastCtx = createContext<PushFn>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [list, setList] = useState<Toast[]>([]);

  const push = useCallback<PushFn>((msg, kind = 'info') => {
    const id = Math.random().toString(36).slice(2);
    setList((l) => [...l, { id, msg, kind }]);
    setTimeout(() => setList((l) => l.filter((t) => t.id !== id)), 3200);
  }, []);

  return (
    <ToastCtx.Provider value={push}>
      {children}
      <div
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          zIndex: 50,
          pointerEvents: 'none',
        }}
      >
        {list.map((t) => (
          <div
            key={t.id}
            className="glass"
            style={{
              padding: '10px 14px',
              fontSize: 13,
              fontWeight: 500,
              pointerEvents: 'auto',
              borderColor:
                t.kind === 'ok' ? 'rgba(16,185,129,0.4)' : undefined,
            }}
          >
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
